module.exports = __webpack_public_path__ + "distribution/img/header_x3.4e023cd8.png";